import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

// Connects to data-controller="chat"
export default class extends Controller {
  connect() {
    console.log("chat connected!")
    this.sub = this.CreateActionCableChannel();
    console.log(this.sub)

    $(".btn-chat").on("click",function(e) {
        e.preventDefault()
        $.ajax({
            type: "POST",
            url: "chat/msg",
            data: {
                from: $("#from").val(),
                msg: $("#msg").val(),
            },
        });
    })
    $(".btn-actbtn").on("click",function(e) {
        e.preventDefault()

        var act = $(this).data("act")
        var extra = $(this).data("extra")

        $.ajax({
            type: "POST",
            url: "chat/act",
            data: {
                from: $("#from").val(),
                msg: $("#msg").val(),
                act: act,
                extra: extra,
            },
        });
    })
  }

  CreateActionCableChannel(){

    return consumer.subscriptions.create("ChatChannel", {
      connected() {
        console.log("CreateActionCableChannel connected!")
      },

      disconnected() {
        console.log("CreateActionCableChannel disconnected!")
      },

      received(data) {
        console.log("CreateActionCableChannel data",data)
        //$("#chat").prepend("<div><b>"+data.from+"</b>"+data.msg+"</div>")
        var ed = false
        if(data.extra){
          ed = JSON.stringify(data.extra)
        }
        $("#chat").prepend("<div><b>"+data.from+"</b> ("+data.act+")"+data.msg+" <br><pre>"+ed+"</pre></div>")
      }
    });


  }

}
